module.exports = __webpack_public_path__ + "static/note-location-do-f60051b94560d78f9855834e7b2affd3.png";